
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle, RefreshCw, Trash2 } from 'lucide-react';

interface Props { children?: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false, error: null };
  declare props: Readonly<Props>;

  constructor(props: Props) { super(props); }
  
  static getDerivedStateFromError(error: Error): State { return { hasError: true, error }; }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) { console.error("Uncaught error:", error, errorInfo); }
  handleReset = () => { if (confirm("This will wipe all local data and reset. Proceed?")) { localStorage.clear(); window.location.reload(); } };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen w-full flex items-center justify-center p-4 bg-[#0f172a] relative overflow-hidden">
          <div className="max-w-md w-full bg-black/80 border border-white/10 rounded-3xl p-8 flex flex-col items-center text-center relative z-10 animate-in fade-in zoom-in duration-300">
             <AlertTriangle size={40} className="text-kfppc-red mb-6" />
             <h1 className="text-3xl font-black text-white mb-2">System Fault</h1>
             <p className="text-kfppc-lavender mb-6">Something unexpected happened.</p>
             {this.state.error && <div className="w-full bg-black/40 rounded-lg p-4 mb-6 text-left overflow-auto max-h-32 border border-white/10"><code className="text-xs text-red-300 font-mono break-words">{this.state.error.toString()}</code></div>}
             <div className="grid gap-3 w-full">
               <button onClick={() => window.location.reload()} className="w-full py-3 bg-white/10 hover:bg-white/20 text-white font-bold rounded-xl transition-colors flex items-center justify-center gap-2"><RefreshCw size={18} /> Try Reloading</button>
               <button onClick={this.handleReset} className="w-full py-3 bg-kfppc-red hover:bg-red-700 text-white font-bold rounded-xl transition-all shadow-lg flex items-center justify-center gap-2"><Trash2 size={18} /> Reset Data</button>
             </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
